import React from 'react';
import Title from '../title/title.js';
import modules_c372949e from './my_orders_section_divider.module.scss.js';

const MyOrdersSectionDivider = ({ type = "completed", title = "Completed" }) => {
    const renderMyOrdersSectionDivider = () => (React.createElement("div", { className: modules_c372949e["my-orders-section-divider-container"] },
        React.createElement("div", { className: modules_c372949e[`my-orders-section-${type}-divider-title-container`], "data-testid": "mbw-my-orders-section-divider-title-container" },
            React.createElement(Title, { fontStyle: "content-default", bold: true }, title)),
        React.createElement("div", { className: modules_c372949e[`my-orders-section-${type}-divider-line-container`], "data-testid": "mbw-my-orders-section-divider-line-container" })));
    return renderMyOrdersSectionDivider();
};

export { MyOrdersSectionDivider as default };
//# sourceMappingURL=my_orders_section_divider.js.map
